import HttpRepository from './httpRepository';

import type { AxiosError, AxiosResponse } from 'axios';

export type UserSettingResponse = string[];
export type UserSettingRequest = 'selectedTeamID';

export type SaveUserSettingsRequest = { selectedTeamID: string } & Record<string, unknown>;

export const UserSettingRepository = {
	getUserSettings: async (settingName: UserSettingRequest) => {
		const response: AxiosResponse<UserSettingResponse, AxiosError> = await HttpRepository.tradeshiftGo().get(
			`/rest/userSettings/${settingName}`,
		);

		return response.data;
	},

	saveUserSetting: async (settingsValues: SaveUserSettingsRequest) => {
		const response: AxiosResponse = await HttpRepository.tradeshiftGo().post('/rest/userSettings/save', settingsValues);
		return response.data;
	},
};
